export default "__VITE_ASSET__CZthZzBS__"